import gql from 'graphql-tag'

let cities = JSON.parse(localStorage.getItem('cities'))
let finalCondition = '{}';
let intermediateCondition = '';
if(cities && cities.length){
    cities.forEach(function(curnt){
        let cityStr = '{address: {_contains: [{city:"'+ curnt.city +'"}]}},'
        intermediateCondition = intermediateCondition + cityStr
    })
    finalCondition = intermediateCondition
}

export const SUBSCRIBE_COMPANIES = gql`
  subscription ($searchFilter: String!){
    company (where: {_and: [{_or: [${finalCondition}] },
    {_or: [{name: {_ilike: $searchFilter}},{mobile: {_ilike: $searchFilter}},{email: {_ilike: $searchFilter}},{gstin: {_ilike: $searchFilter}}] }
    ]}){
      id
      name
      email
      mobile
      gstin
      address
      type
      routes
    }
  }
`

export const SUBSCRIBE_EXCEL_COMPANIES = gql`
  subscription ($searchFilter: String!, $city:jsonb!, $companyTypes:[uuid!], $isApproved:Boolean, $isRejected:Boolean, $offset: Int!, $limit: Int!){
    clients: company (where: {_and: [{_or: [${finalCondition}] },{address: {_contains: $city}},{type: {_in: $companyTypes}},{isApproved: {_eq: $isApproved}},{isRejected: {_eq: $isRejected}},
    {_or: [{name: {_ilike: $searchFilter}},{mobile: {_ilike: $searchFilter}},{email: {_ilike: $searchFilter}},{gstin: {_ilike: $searchFilter}},
           {companyUsers: {name: {_ilike: $searchFilter}}},{companyUsers: {mobile: {_ilike: $searchFilter}}},{companyUsers: {email: {_ilike: $searchFilter}}}] }]},
            offset: $offset, limit: $limit){
      id
      name
      email
      mobile
      gstin
      address
      routes
      isApproved
      isRejected
      typeByType{id name}
      preference
      orders_aggregate { aggregate { count } }
    }
  }
`

export const SUBSCRIBE_COMPANIES_TOTALCOUNT = gql`
  subscription ($searchFilter: String!, $city:jsonb!, $companyTypes:[uuid!], $isApproved:Boolean, $isRejected:Boolean){
    clientsCount: company_aggregate (where: {_and: [{_or: [${finalCondition}] },{address: {_contains: $city}},{type: {_in: $companyTypes}},{isApproved: {_eq: $isApproved}},{isRejected: {_eq: $isRejected}},
    {_or: [{name: {_ilike: $searchFilter}},{mobile: {_ilike: $searchFilter}},{email: {_ilike: $searchFilter}},{gstin: {_ilike: $searchFilter}},
           {companyUsers: {name: {_ilike: $searchFilter}}},{companyUsers: {mobile: {_ilike: $searchFilter}}},{companyUsers: {email: {_ilike: $searchFilter}}}] }
    ]}){
       aggregate{count}
    }
  }
`
export const SUBSCRIBE_ORDERS_BY_COMPANY_ID = gql`
 subscription orders_by_companyId($companyId:uuid!, $stageFilter:[uuid!], $searchFilter: String!, $lrName: jsonb!, $materialType:jsonb!,
                                  $startDate:timestamptz!, $endDate:timestamptz!, $pickupCity:jsonb!, $dropCity:jsonb!){
  orders(where:{_and: [ {clientid:{_eq: $companyId}}, {internalstatus: {_in: $stageFilter}}, {materials: {_contains: $materialType}},{pickupDate: {_gte: $startDate}},
                      {pickupDate: {_lte: $endDate}}, {pickuppartyobject: {_contains: $pickupCity}}, {droppingpartyobject: {_contains: $dropCity}},
     {_or: [{orderNumber: {_ilike: $searchFilter}},{Client: {name: {_ilike: $searchFilter}}},{PickupParty: {name: {_ilike: $searchFilter}}},
     {DropParty: {name: {_ilike: $searchFilter}}},{orderDetails: {lrObject: {_contains: $lrName}}}]} ]}, order_by: {createdAt: desc}) {
      id
      clientobject
      pickuppartyobject
      droppingpartyobject
      orderNumber
      pickupDate
      createdAt
      updated_at
      materials
      priority
      note
      notes(order_by: {createdOn: desc}, limit: 1){id note}
      internalstatus
      internalStatus{id name viewPath}
      orderDetails {
        id
        lrObject
        pickupConfirmation
        orderReadiness
        dispactchVerification
        pickupVehicleAssignId
        transportVehicleAssignId
        loadedInTruck
        ewayBillNo
        isEwayBillVerified
        pickupPoint
        dropPoint
      }
    }
 }
`
export const SUBSCRIBE_EXCEL_TRANSPORTERS = gql`
  subscription transporters($searchFilter: String!, $city:jsonb!, $typeId:uuid!, $isApproved:Boolean, $isRejected:Boolean, $offset: Int!, $limit: Int!){
    transporters: company (where: {_and: [{_or: [${finalCondition}] },{address: {_contains: $city}},{type: {_eq: $typeId}}, {isApproved: {_eq: $isApproved}},{isRejected: {_eq: $isRejected}},
    {_or: [{name: {_ilike: $searchFilter}},{mobile: {_ilike: $searchFilter}},{email: {_ilike: $searchFilter}},{gstin: {_ilike: $searchFilter}}] }]},
     offset: $offset, limit: $limit){
      id
      name
      email
      mobile
      gstin
      address
      routes
      isApproved
      isRejected
      typeByType{id name}
      orders_aggregate { aggregate { count } }
      truckOrders_aggregate { aggregate { count } }
      trucks_aggregate { aggregate { count } }
      drivers_aggregate { aggregate { count } }
    }
  }
`
                                                      /*{isApproved: {_eq: false}}, {isRejected: {_eq: false}}*/
                                                      /*{_or: [{name: {_ilike: $searchFilter}},{mobile: {_ilike: $searchFilter}},{email: {_ilike: $searchFilter}},{gstin: {_ilike: $searchFilter}}] }*/
export const SUBSCRIBE_CLIENT_REQUEST = gql`
  subscription ($limit: Int!){
    company (where: {_and: [{_or: [${finalCondition}] },{isApproved: {_eq: true}} ]}, limit: $limit, order_by: {created_at: desc}){
      id
      name
      email
      mobile
      gstin
      address
      type
      routes
      isApproved
      isRejected
    }
  }
`
export const SUBSCRIBE_CONTACTS_BY_COMPANY_ID = gql`
subscription ($companyId: uuid!){
  contacts (where:{clientid:{_eq:$companyId}}) {
      name
      mobile
      role
      email
      id
  }
}
`
export const SUBSCRIBE_USERS_BY_COMPANY_ID = gql`
subscription ($companyId: uuid!){
  users: CompnayUser (where:{clientid:{_eq:$companyId}}) {
      name
      mobile
      role
      email
      id
  }
}
`
export const SUBSCRIBE_CLIENT_DETAIL_BY_COMPANY_ID = gql`
subscription ($companyId: uuid!){
  clientDetail: company(where:{id:{_eq:$companyId}}) {
    id
    address
    email
    gstin
    mobile
    name
    isApproved
    isRejected
    typeByType {id name }
    preference
    AddressbookCompany {id}
  }
}
`

export const SUBSCRIBE_TRANSPORTER_DETAIL = gql`
subscription subscribeTransporterDetail($companyId:uuid!){
  transporterDetail: company(where: {id: {_eq: $companyId}}) {
    id
    address
    email
    gstin
    mobile
    name
    routes
    isApproved
    isRejected
    trucks{ id name platNo capacity routes kmLimit}
    drivers{ id  name mobile driverType proof status}
   }
}
`
